import React, {createRef, PureComponent} from "react"

import {StyledInput} from "./styled"

interface Props {
  value: number
  width: number
  onUpdateValue: (value: number) => void
}

class RangeInput extends PureComponent<Props> {
  rangeInput = createRef<HTMLInputElement>()

  render() {
    const {onUpdateValue, ...rest} = this.props

    const onChange = () => {
      if (this.rangeInput.current) {
        const value = parseInt(this.rangeInput.current.value, 10)
        onUpdateValue(value)

        this.rangeInput.current.valueAsNumber = value
      }
    }

    return (
      <StyledInput className="range-input" type="range" min="25" max="150" step="1" onChange={onChange} ref={this.rangeInput} {...rest} />
    )
  }
}

export default RangeInput
